import service from '@/store/services/observed-service';

const state = {
  observed: null,
  namespaced: true,
};

const mutations = {
  SET_RESOURCE: (state, observed) => {
    state.observed = observed;
  }
};

const actions = {
  observed({commit, dispatch}, params) {
    return service.get(params)
      .then((profile) => {
        commit('SET_RESOURCE', profile.list);
      });
  }
};

const getters = {
  observed: state => state.observed,
  observedRoute: state => process.env.VUE_APP_API_BASE_URL + '/users/' + state.observed.slug,
  avatar: state => state.observed.avatar,
  grandfathered: state => state.observed.grandfathered,
  subBasic: (state, getters, rootState, rootGetters) => {
    const plans = [
      process.env.VUE_APP_STRIPE_BASIC,
      process.env.VUE_APP_STRIPE_STANDARD,
      process.env.VUE_APP_STRIPE_PREMIUM
    ];
    return plans.includes(state.observed.subscription) || getters.grandfathered;
  },
  subStandard: (state, getters, rootState, rootGetters) => {
    const plans = [
      process.env.VUE_APP_STRIPE_STANDARD,
      process.env.VUE_APP_STRIPE_PREMIUM
    ];
    return plans.includes(state.observed.subscription) || getters.grandfathered;
  },
  subPremium: (state, getters, rootState, rootGetters) => {
    const plans = [
      process.env.VUE_APP_STRIPE_PREMIUM
    ];
    return plans.includes(state.observed.subscription) || getters.grandfathered;
  },
};

const profile = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default profile;
